import * as React from 'react';
import { Platform } from 'react-native';
import { BelongsToScreen } from 'screens/AssessmentScreen/Pages/BelongsToScreen';
import { HistoryScreen } from 'screens/AssessmentScreen/Pages/HistoryScreen/HistoryScreen';
import { ActionEdit } from 'screens/AssessmentScreen/PagesMain/ActionEdit';
import { ControlEdit } from 'screens/AssessmentScreen/PagesMain/ControlEdit';
import { ActionScreen } from 'screens/AssessmentSetupLibraryScreen/ActionScreen';
import { ActionsListScreen } from 'screens/AssessmentSetupLibraryScreen/ActionsListScreen';
import { AnswerScreen } from 'screens/AssessmentSetupLibraryScreen/AnswerScreen';
import { ChecklistItemScreen } from 'screens/AssessmentSetupLibraryScreen/ChecklistItemScreen';
import { ControlScreen } from 'screens/AssessmentSetupLibraryScreen/ControlScreen';
import { ControlsListScreen } from 'screens/AssessmentSetupLibraryScreen/ControlsListScreen';
import { FolderScreen } from 'screens/AssessmentSetupLibraryScreen/FolderScreen';
import { QuestionScreen } from 'screens/AssessmentSetupLibraryScreen/QuestionScreen';
import { SectionScreen } from 'screens/AssessmentSetupLibraryScreen/SectionScreen';
import { FieldRepeatableInstanceScreenNew } from 'screens/AssetScreen/Field/FieldRepeatableInstanceScreenNew';
import { CreateAssetScreen } from 'screens/CreateAssetScreen/CreateAssetScreen';
import { FileManagerFilesScreen } from 'screens/FileManager/FileManagerFilesScreen';
import { PdfViewerScreen } from 'screens/PdfViewerScreen';
import { ProfileEmailScreen } from 'screens/ProfileScreen/ProfileEmailScreen';
import { ProfileDetailsScreen } from 'screens/ProfileScreen/ProfileDetailsScreen';
import { ProfilePasswordScreen } from 'screens/ProfileScreen/ProfilePasswordScreen';
import { ProfileTfaScreen } from 'screens/ProfileScreen/ProfileTfaScreen';
import { QRScannerScreen } from 'screens/QRScannerScreen/QRScannerScreen';
import { QRViewerScreen } from 'screens/QRViewerScreen/QRViewerScreen';
import { SelectScreen } from 'screens/SelectScreen';
import { SyncErrorsScreen } from 'screens/SyncScreen/SyncErrorsScreen';
import { TemplateScreen } from 'screens/AssessmentSetupScreen/TemplateScreen';
import { QuestionListScreen } from 'screens/AssessmentSetupScreen/QuestionListScreen';
import { ReorderScreen } from 'screens/ReorderScreen';
import { ExplorerOptionsModal } from 'screens/AssessmentScreen/Explorer/ExplorerOptionsModal';
import { CreateAssessmentScreen } from 'screens/AssetScreen/Compliance/CreateAssessmentScreen';
import { QuickAnswerChecklistModal } from 'screens/AssessmentScreen/PagesMain/QuickAnswerChecklistModal';
import { CopyAssessmentScreen } from 'screens/AssessmentScreen/Pages/CopyAssessmentScreen';
import { RiskRatingScreen } from 'screens/AssessmentScreen/Pages/RiskRatingScreen';
import { RepeatableInstanceScreen } from 'screens/AssessmentScreen/Repeatable/RepeatableInstanceScreen';
import { AddRepeatableListScreen } from 'screens/AssessmentScreen/Repeatable/AddRepeatableListScreen';
import { CanvasInfo } from 'screens/PlanScreen/Pins/CanvasInfo';
import { FieldInstancesOptionsModal } from 'screens/AssetScreen/Field/FieldInstancesOptionsModal';
import { RepeatableOptionsModal } from 'screens/AssessmentScreen/Repeatable/RepeatableOptionsModal';
import { MakeSuggestionModal } from 'screens/AssessmentScreen/MakeSuggestionModal';
import { FieldsScreen as FieldsScreenSetup } from 'screens/AssessmentSetupScreen/FieldsScreen';
import { CloudAssetsScreen } from 'screens/CloudAssetsScreen/CloudAssetsScreen';
import { FieldSettingsSectionModal } from 'screens/FieldSettings/FieldSettingsSectionModal';
import { FieldSettingsLinkCustomerModal } from 'screens/FieldSettings/FieldSettingsLinkCustomerModal';
import { FieldSettingsGroupModal } from 'screens/FieldSettings/FieldSettingsGroupModal';
import { FieldSettingsFieldModal } from 'screens/FieldSettings/FieldSettingsFieldModal';
import { FieldSettingsFieldCriteriaModal } from 'screens/FieldSettings/FieldSettingsFieldCriteriaModal';
import { PlanListModal } from 'screens/PlanScreen/PlanListModal';
import { PlanScreen } from 'screens/PlanScreen/PlanScreen';
import { PlanCreateModal } from 'screens/PlanScreen/PlanCreateModal';
import { LinkQuestionListScreen } from 'screens/AssessmentSetupLibraryScreen/LinkQuestionListScreen';
import { AssessmentListFilter } from 'screens/AssessmentsTab/AssessmentListFilter';
import { EngageFlatsFilterModal } from 'screens/EngageScreen/EngageFlatsFilterModal';
import { StatusApproveModal } from 'screens/AssessmentScreen/PagesMain/StatusApproveModal';
import { StatusUnapproveModal } from 'screens/AssessmentScreen/PagesMain/StatusUnapproveModal';
import { StatusUnsubmitModal } from 'screens/AssessmentScreen/PagesMain/StatusUnsubmitModal';
import { SupportModal } from 'screens/SupportModal';
import { FieldsScreen as FieldsScreenPerform } from 'screens/AssessmentScreen/FieldsScreen';
import { LightRepeatableInstanceModal } from 'screens/AssessmentScreen/Repeatable/LightRepeatableInstanceModal';
import { LightRepeatableInstanceModal as AssetLightRepeatableInstanceModal } from 'screens/AssetScreen/LightRepeatableInstanceModal';
import { QuickAnswerQuestionModal } from 'screens/AssessmentScreen/PagesMain/QuickAnswerQuestionModal';
import { SectionEdit } from 'screens/AssessmentScreen/PagesMain/SectionEdit';
import { SummaryEdit } from 'screens/AssessmentScreen/PagesMain/SummaryEdit';
import { AssetScreen } from 'screens/AssessmentScreen/AssetScreen';
import { AuthorScreen } from 'screens/AssessmentScreen/Pages/AuthorScreen';
import { QuestionEdit } from 'screens/AssessmentScreen/PagesMain/QuestionEdit';
import { FieldSettingsGroupCheckModal } from 'screens/FieldSettings/FieldSettingsGroupCheckModal';
import { AseInstanceCheckEdit } from 'screens/AssessmentScreen/PagesMain/AseInstanceCheckEdit';
import { CheckModal } from 'screens/SettingsAssessmentCompliance/CheckModal';
import { UpgradeRequiredModal } from 'screens/UpgradeModal/UpgradeModal';
import { ReportsSelect } from 'screens/ReportingTab/ReportsSelect';
import { ReportsFilterModal } from 'screens/ReportingTab/ReportsFilterModal';
import { SyncModal } from 'screens/SyncScreen/SyncModal';
import { ApiUserModal } from 'screens/ApiScreen/ApiUserModal';
import { ApiWebhookModal } from 'screens/ApiScreen/ApiWebhookModal';
import { EngageSettingsDocumentModal } from 'screens/EngageSettingsScreen/EngageSettingsDocumentModal';
import { EngageSettingsElementModal } from 'screens/EngageSettingsScreen/EngageSettingsElementModal';
import { EngageSettingsCheckModal } from 'screens/EngageSettingsScreen/EngageSettingsCheckModal';
import { EngageSettingsReportIssueModal } from 'screens/EngageSettingsScreen/EngageSettingsReportIssueModal';
import { EngageSettingsMessagingModal } from 'screens/EngageSettingsScreen/EngageSettingsMessagingModal';
import { BillingProductModal } from 'screens/BillingScreen/BillingProductModal';
import { BillingItemModal } from 'screens/BillingScreen/BillingItemModal';
import { BillingProductUnitsModal } from 'screens/BillingScreen/BillingProductUnitsModal';
import { SsoSettingsIdpModal } from 'screens/SsoSettingsScreen/SsoSettingsIdpModal';
import { OrganisationDetailsModal } from 'screens/OrganisationScreen/OrganisationDetailsModal';
import { OrganisationBillingModal } from 'screens/OrganisationScreen/OrganisationBillingModal';
import { FlagModal } from 'screens/AssessmentScreen/Modals/FlagModal';
import { FlagUnsetModal } from 'screens/AssessmentScreen/Modals/FlagUnsetModal';
import { FlagsSetupModal } from 'screens/AssessmentSetupScreen/FlagsSetupModal';
import { FlagSetupModal } from 'screens/AssessmentSetupScreen/FlagSetupModal';
import { BillingDiscountModal } from 'screens/BillingScreen/BillingDiscountModal';
import { CameraModal } from 'screens/CameraModal/CameraModal';
import { SignatoriesSetupModal } from 'screens/AssessmentSetupScreen/SignatoriesSetupModal';
import { SignatorySetupModal } from 'screens/AssessmentSetupScreen/SignatorySetupModal';
import { SignatoryModal } from 'screens/AssessmentScreen/Modals/SignatoryModal';
import { BillingOrganisationSettingsModal } from 'screens/BillingScreen/BillingOrganisationSettingsModal';
import { ModalScreens } from './Navigation/types';
import { EngageFlatModal } from 'screens/EngageScreen/EngageFlatModal';
import { EngageSendCommunicationModal } from 'screens/EngageScreen/EngageSendCommunicationModal';
import { EngageContactModal } from 'screens/EngageScreen/EngageContactModal';
import { EngageContactEmergencyEvacuationModal } from 'screens/EngageScreen/EngageContactEmergencyEvacuationModal';
import { EngageContactUploadsModal } from 'screens/EngageScreen/EngageContactUploadModal';
import { EngageFlatDoorScheduledVisitModal } from 'screens/EngageScreen/EngageFlatDoorScheduledVisitModal';
import { EngageCancelScheduledVisitModal } from 'screens/EngageScreen/EngageCancelScheduledVisitModal';

export const MODALS: Record<
  ModalScreens,
  {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: React.FC<{ route: { params: any }; isModal?: true }>;
    gestureEnabled?: boolean;
    /**
     * @defaultValue large
     */
    size: 'small' | 'fullscreen' | 'large';
  }
> = {
  [ModalScreens.ReportsSelect]: {
    component: ReportsSelect,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.ReportsFilterModal]: {
    component: ReportsFilterModal,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.CLOUDASSETS]: { component: CloudAssetsScreen, size: 'large' },
  [ModalScreens.CREATEASSET]: { component: CreateAssetScreen, size: 'large' },
  [ModalScreens.SYNCERRORS]: {
    component: SyncErrorsScreen,
    gestureEnabled: true,
    size: 'large',
  },
  [ModalScreens.QR_VIEWER]: {
    component: QRViewerScreen,
    gestureEnabled: true,
    size: 'large',
  },
  [ModalScreens.QR_SCANNER]: {
    component: QRScannerScreen,
    gestureEnabled: true,
    size: 'large',
  },
  [ModalScreens.Camera]: {
    component: CameraModal,
    gestureEnabled: true,
    size: 'fullscreen',
  },
  [ModalScreens.PLANS]: { component: PlanScreen, size: 'fullscreen' },
  [ModalScreens.PLANLIST]: {
    component: PlanListModal,
    gestureEnabled: true,
    size: 'large',
  },
  [ModalScreens.PLANINFO]: {
    component: CanvasInfo,
    gestureEnabled: true,
    size: 'large',
  },
  [ModalScreens.PLANCREATE]: {
    component: PlanCreateModal,
    gestureEnabled: true,
    size: 'small',
  },

  [ModalScreens.SELECT]: {
    component: SelectScreen,
    gestureEnabled: true,
    size: 'large',
  },
  [ModalScreens.Support]: {
    component: SupportModal,
    gestureEnabled: true,
    size: 'small',
  },
  [ModalScreens.REORDER]: {
    component: ReorderScreen,
    gestureEnabled: true,
    size: 'large',
  },

  // Asset
  [ModalScreens.FIELDINSTANCESOPTIONS]: {
    component: FieldInstancesOptionsModal,
    gestureEnabled: true,
    size: 'small',
  },
  [ModalScreens.AstLightRepeatableInstance]: {
    component: AssetLightRepeatableInstanceModal,
    size: 'large',
  },

  [ModalScreens.Sync]: {
    component: SyncModal,
    size: 'small',
    gestureEnabled: true,
  },

  [ModalScreens.UpgradeRequired]: {
    component: UpgradeRequiredModal,
    size: 'small',
    gestureEnabled: true,
  },

  // Files
  [ModalScreens.PDFVIEWER]: {
    component: PdfViewerScreen,
    size: Platform.OS === 'ios' ? 'large' : 'fullscreen',
    gestureEnabled: true,
  },
  [ModalScreens.FILEMANAGER]: {
    component: FileManagerFilesScreen,
    gestureEnabled: true,
    size: 'large',
  },
  // Fields
  [ModalScreens.NEWREPEATABLEINSTANCE]: {
    component: FieldRepeatableInstanceScreenNew,
    size: 'large',
  },
  // Assessments
  [ModalScreens.CREATEASSESSMENT]: {
    component: CreateAssessmentScreen,
    gestureEnabled: true,
    size: 'large',
  },
  [ModalScreens.ASEEXPLOREROPTIONS]: {
    component: ExplorerOptionsModal,
    gestureEnabled: true,
    size: 'small',
  },
  [ModalScreens.ASEHISTORY]: {
    component: HistoryScreen,
    gestureEnabled: true,
    size: 'large',
  },
  [ModalScreens.ASECOPY]: {
    component: CopyAssessmentScreen,
    gestureEnabled: true,
    size: 'large',
  },
  [ModalScreens.ASERISKRATING]: {
    component: RiskRatingScreen,
    gestureEnabled: true,
    size: 'large',
  },
  [ModalScreens.AseAuthor]: {
    component: AuthorScreen,
    gestureEnabled: true,
    size: 'small',
  },
  [ModalScreens.ASEFINDINGBELONGSTO]: {
    component: BelongsToScreen,
    gestureEnabled: true,
    size: 'large',
  },
  [ModalScreens.AseSummary]: { component: SummaryEdit, size: 'large' },
  [ModalScreens.AseSection]: { component: SectionEdit, size: 'large' },
  [ModalScreens.AseInstanceCheck]: {
    component: AseInstanceCheckEdit,
    size: 'large',
  },
  [ModalScreens.AseQuestion]: { component: QuestionEdit, size: 'large' },
  [ModalScreens.AseFields]: { component: FieldsScreenPerform, size: 'large' },
  [ModalScreens.AseAction]: { component: ActionEdit, size: 'large' },
  [ModalScreens.AseControl]: { component: ControlEdit, size: 'large' },
  [ModalScreens.AseFieldInstance]: {
    component: RepeatableInstanceScreen,
    size: 'large',
  },
  [ModalScreens.AseAssetDetails]: {
    component: AssetScreen,
    size: 'large',
  },
  [ModalScreens.AseFlag]: {
    component: FlagModal,
    size: 'small',
  },
  [ModalScreens.AseFlagUnset]: {
    component: FlagUnsetModal,
    size: 'small',
  },
  [ModalScreens.AseSignatory]: {
    component: SignatoryModal,
    size: 'small',
  },
  [ModalScreens.AseLightRepeatableInstance]: {
    component: LightRepeatableInstanceModal,
    size: 'large',
  },
  [ModalScreens.AseFieldInstancesOptions]: {
    component: RepeatableOptionsModal,
    gestureEnabled: true,
    size: 'small',
  },
  [ModalScreens.ASEREPEATABLEINSTANCENEWFROMLIST]: {
    component: AddRepeatableListScreen,
    size: 'large',
  },
  [ModalScreens.AseQuickAnswerChecklist]: {
    component: QuickAnswerChecklistModal,
    size: 'small',
  },
  [ModalScreens.AseQuickAnswerQuestion]: {
    component: QuickAnswerQuestionModal,
    size: 'small',
  },
  [ModalScreens.AseMakeSuggestion]: {
    component: MakeSuggestionModal,
    size: 'large',
  },
  [ModalScreens.AseStatusApprove]: {
    component: StatusApproveModal,
    size: 'small',
  },
  [ModalScreens.AseStatusUnapprove]: {
    component: StatusUnapproveModal,
    size: 'small',
  },
  [ModalScreens.AseStatusUnsubmit]: {
    component: StatusUnsubmitModal,
    size: 'small',
  },

  // Settings - Assessment - Template
  [ModalScreens.SettingsAseCheck]: {
    component: CheckModal,
    size: 'large',
  },

  // Assessment Setup Template
  [ModalScreens.ASESETUPTEMPLATE]: {
    component: TemplateScreen,
    size: 'large',
  },
  [ModalScreens.ASESETUPTEMPLATEQUESTIONLIST]: {
    component: QuestionListScreen,
    size: 'large',
  },
  [ModalScreens.ASESETUPTEMPLATEFIELDS]: {
    component: FieldsScreenSetup,
    size: 'large',
  },

  // Assessment Setup Library
  [ModalScreens.ASESETUPLIBRARYFOLDER]: {
    component: FolderScreen,
    size: 'small',
  },
  [ModalScreens.ASESETUPLIBRARYSECTION]: {
    component: SectionScreen,
    size: 'large',
  },
  [ModalScreens.ASESETUPLIBRARYQUESTION]: {
    component: QuestionScreen,
    size: 'large',
  },
  [ModalScreens.ASESETUPLIBRARYANSWER]: {
    component: AnswerScreen,
    size: 'large',
  },
  [ModalScreens.ASESETUPLIBRARYCHECKLISTITEM]: {
    component: ChecklistItemScreen,
    size: 'large',
  },
  [ModalScreens.ASESETUPLIBRARYACTIONSLIST]: {
    component: ActionsListScreen,
    size: 'large',
  },
  [ModalScreens.ASESETUPLIBRARYCONTROLSLIST]: {
    component: ControlsListScreen,
    size: 'large',
  },
  [ModalScreens.ASESETUPLIBRARYACTION]: {
    component: ActionScreen,
    size: 'large',
  },
  [ModalScreens.ASESETUPLIBRARYCONTROL]: {
    component: ControlScreen,
    size: 'large',
  },
  [ModalScreens.ASESETUPLIBRARYLINKQUESTIONS]: {
    component: LinkQuestionListScreen,
    size: 'large',
  },
  [ModalScreens.AseSetupFlags]: {
    component: FlagsSetupModal,
    // size: 'small', // issue with formSheet
    size: 'large',
    gestureEnabled: true,
  },
  [ModalScreens.AseSetupFlag]: {
    component: FlagSetupModal,
    size: 'small',
  },
  [ModalScreens.AseSetupSignatories]: {
    component: SignatoriesSetupModal,
    // size: 'small', // issue with formSheet
    size: 'large',
    gestureEnabled: true,
  },
  [ModalScreens.AseSetupSignatory]: {
    component: SignatorySetupModal,
    size: 'small',
  },

  // Assessments Online
  [ModalScreens.AsesListFilter]: {
    component: AssessmentListFilter,
    size: 'small',
  },

  // Engage
  [ModalScreens.EngageFlatsFilter]: {
    component: EngageFlatsFilterModal,
    size: 'small',
  },
  [ModalScreens.EngageContactUpload]: {
    component: EngageContactUploadsModal,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.EngageFlatDoorScheduledVisit]: {
    component: EngageFlatDoorScheduledVisitModal,
    size: 'large',
    gestureEnabled: true,
  },
  [ModalScreens.EngageCancelScheduledVisit]: {
    component: EngageCancelScheduledVisitModal,
    size: 'large',
    gestureEnabled: true,
  },

  // Field Settings
  [ModalScreens.FieldSettingsSection]: {
    component: FieldSettingsSectionModal,
    size: 'large',
  },
  [ModalScreens.FieldSettingsGroup]: {
    component: FieldSettingsGroupModal,
    size: 'large',
  },
  [ModalScreens.FieldSettingsGroupCheck]: {
    component: FieldSettingsGroupCheckModal,
    size: 'small',
  },
  [ModalScreens.FieldSettingsLiteGroup]: {
    component: FieldSettingsGroupModal,
    size: 'large',
  },
  [ModalScreens.FieldSettingsField]: {
    component: FieldSettingsFieldModal,
    size: 'large',
  },
  [ModalScreens.FieldSettingsSectionLinkCustomer]: {
    component: FieldSettingsLinkCustomerModal,
    size: 'small',
  },
  [ModalScreens.FieldSettingsFieldCriteria]: {
    component: FieldSettingsFieldCriteriaModal,
    size: 'small',
  },

  // Profile
  [ModalScreens.SETTINGSPROFILEDETAILS]: {
    component: ProfileDetailsScreen,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.SETTINGSPROFILEEMAIL]: {
    component: ProfileEmailScreen,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.SETTINGSPROFILEPASSWORD]: {
    component: ProfilePasswordScreen,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.SETTINGSPROFILETFA]: {
    component: ProfileTfaScreen,
    size: 'small',
    gestureEnabled: true,
  },

  /**
   * Engage Settings
   */
  [ModalScreens.SettingsEngageDocument]: {
    component: EngageSettingsDocumentModal,
    size: 'large',
    gestureEnabled: true,
  },
  [ModalScreens.SettingsEngageElement]: {
    component: EngageSettingsElementModal,
    size: 'large',
    gestureEnabled: true,
  },
  [ModalScreens.SettingsEngageCheck]: {
    component: EngageSettingsCheckModal,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.SettingsEngageReportIssue]: {
    component: EngageSettingsReportIssueModal,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.SettingsEngageMessaging]: {
    component: EngageSettingsMessagingModal,
    size: 'small',
    gestureEnabled: true,
  },

  /**
   * API Settings
   */
  [ModalScreens.SettingsApiUser]: {
    component: ApiUserModal,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.SettingsApiWebhook]: {
    component: ApiWebhookModal,
    size: 'small',
    gestureEnabled: true,
  },

  /**
   * Billing
   */
  [ModalScreens.SettingsBillingOrganisation]: {
    component: BillingOrganisationSettingsModal,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.SettingsBillingProduct]: {
    component: BillingProductModal,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.SettingsBillingProductUnits]: {
    component: BillingProductUnitsModal,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.SettingsBillingItem]: {
    component: BillingItemModal,
    size: 'small',
    gestureEnabled: true,
  },
  [ModalScreens.SettingsBillingDiscount]: {
    component: BillingDiscountModal,
    size: 'small',
    gestureEnabled: true,
  },

  /**
   * SSO Settings
   */
  [ModalScreens.SettingsSsoIdp]: {
    component: SsoSettingsIdpModal,
    size: 'small',
    gestureEnabled: true,
  },

  /**
   * Organisation Settings
   */
  [ModalScreens.SettingsOrganisationDetailsModal]: {
    component: OrganisationDetailsModal,
    size: 'large',
    gestureEnabled: true,
  },
  [ModalScreens.SettingsOrganisationBillingModal]: {
    component: OrganisationBillingModal,
    size: 'large',
    gestureEnabled: true,
  },

  /**
   * Engage
   */
  [ModalScreens.EngageFlat]: {
    component: EngageFlatModal,
    size: 'large',
    gestureEnabled: true,
  },
  [ModalScreens.EngageContact]: {
    component: EngageContactModal,
    size: 'large',
    gestureEnabled: true,
  },
  [ModalScreens.EngageContactEmergencyEvacuation]: {
    component: EngageContactEmergencyEvacuationModal,
    size: 'large',
    gestureEnabled: true,
  },
  [ModalScreens.EngageSendCommunication]: {
    component: EngageSendCommunicationModal,
    size: 'small',
    gestureEnabled: true,
  },
};
